/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:fixed;top:0;bottom:0;left:0;right:0;display:flex;justify-content:center;align-items:center;background:#f3eef8;padding:20px}"];
export { styles as styles };
